<template>
    <zen-message-modal :isOpen="isOpen" title="Delete Draft Target">
        Are you sure you want to delete this draft? This action is permanent.
        <template v-slot:buttons>
            <zen-button
                variant="primary-danger"
                @click="$emit('confirm')"
                :disabled="processing"
            >
                {{ processing ? 'Please wait' : 'Delete' }}
            </zen-button>
            <zen-button
                variant="secondary"
                @click="$emit('close')"
                :disabled="processing"
            >
                Cancel
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'DeleteDraftTargetModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
